module.exports = __webpack_public_path__ + "static/media/roller.768bfcf3.svg";